<footer aria-labelledby="footer-company-name" class="site-footer">
  <div class="site-footer__container">
    <div class="site-footer__primary">
      <details [open]="!isMobile" class="site-footer__company">
        <summary>
          <h2 id="footer-company-name">주식회사 체크팀</h2>
          <span aria-hidden="true" class="site-footer__details-chevron material-symbols-outlined">keyboard_arrow_down</span>
        </summary>
        <div class="site-footer__identity">
          <p>복잡한 부동산 정보, 더 쉽고 안전하게 확인하세요.</p>
        </div>

        <address class="site-footer__address">
          <p>
            <span>대표 김대훈</span>
            <span>사업자등록번호 522-81-00931</span>
            <span>통신판매업신고 2018-서울강남-00730</span>
          </p>
          <p>서울 강남구 영동대로76길 10, 2층 체크팀</p>
          <p>
            <a href="mailto:ask@checkteam.ai">ask&#64;checkteam.ai</a>
            <a href="tel:02-555-0324">고객센터 02-555-0324</a>
            <span>개인정보관리책임자 김대훈</span>
          </p>
        </address>
      </details>

      <details [open]="!isMobile" class="site-footer__nav">
        <summary>
          <h2>고객지원</h2>
          <span aria-hidden="true" class="site-footer__details-chevron material-symbols-outlined">keyboard_arrow_down</span>
        </summary>
        <nav aria-label="고객지원" class="site-footer__nav-list">
          <a [queryParams]="{ type: 'INQUIRE' }" routerLink="/inquire">1:1 문의</a>
          <a [queryParams]="{ type: 'ERROR' }" routerLink="/inquire">긴급 오류신고</a>
          <a [queryParams]="{ type: 'SUGGEST' }" routerLink="/inquire">서비스 기능요청</a>
          <a [queryParams]="{ type: 'NOTICE' }" routerLink="/info/notice">공지사항</a>
          <a [queryParams]="{ type: 'UPDATE' }" routerLink="/info/update">업데이트</a>
          <a [queryParams]="{ type: 'EVENT' }" routerLink="/info/events">이벤트</a>
          <a href="/guides/index.html">부동산 가이드</a>
          <a routerLink="/info/company">회사소개</a>
          <a href="https://apps.apple.com/kr/app/id1578403569" rel="noopener noreferrer" target="_blank">App Store 다운로드</a>
          <a href="https://play.google.com/store/apps/details?id=kr.co.lawalliance.checkteam" rel="noopener noreferrer" target="_blank">Google Play 다운로드</a>
        </nav>
      </details>

      <section aria-labelledby="footer-contact-title" class="site-footer__contact">
        <div>
          <h2 id="footer-contact-title">궁금한 점을 바로 물어보세요</h2>
          <p class="site-footer__contact-copy">채팅 상담으로 더 빠르게 안내해 드릴게요.</p>
        </div>

        <div class="site-footer__chat-list">
          <button (click)="openChat('https://pf.kakao.com/_SRues/chat')" type="button">
            <span class="site-footer__chat-icon">
              <img alt="" src="/assets/img/platform/sns-kakao-black.svg"/>
            </span>
            <span>
              <strong>카카오톡 문의</strong>
              <small>체크팀 채널로 상담하기</small>
            </span>
            <span aria-hidden="true" class="site-footer__arrow">↗</span>
          </button>

          <button (click)="openChat('https://talk.naver.com/W4GHRN?ref=https%3A%2F%2Fcheckteam.co.kr')"
                  type="button">
            <span class="site-footer__chat-icon">
              <img alt="" src="/assets/img/platform/sns-naver-black.svg"/>
            </span>
            <span>
              <strong>네이버톡 문의</strong>
              <small>네이버 톡톡으로 상담하기</small>
            </span>
            <span aria-hidden="true" class="site-footer__arrow">↗</span>
          </button>
        </div>
      </section>
    </div>

    <div class="site-footer__legal">
      <a routerLink="/terms/service">이용약관</a>
      <a class="site-footer__legal--emphasis" routerLink="/terms/privacy">개인정보 처리방침</a>
      <button (click)="openAnalysisSettings()" type="button">분석 정보 설정</button>
      <button #tooltip="matTooltip"
              (click)="tooltip.toggle()"
              matTooltip="본 웹사이트에 게시된 이메일 주소가 전자우편 수집프로그램이나 그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반할 경우 관련 법률에 따라 처벌받을 수 있습니다."
              matTooltipPosition="above"
              type="button">
        이메일 무단수집거부
      </button>
    </div>

    <details [open]="!isMobile" aria-labelledby="footer-patent-title" class="site-footer__patent">
      <summary>
        <div class="site-footer__patent-heading">
          <div class="site-footer__patent-mark">
            <img alt="특허청" src="/assets/img/service/kipo.png"/>
          </div>
          <div>
            <p class="site-footer__eyebrow">PATENTED TECHNOLOGY</p>
            <h2 id="footer-patent-title">체크팀의 권리분석 기술은<br/>특허법에 의해 보호됩니다.</h2>
          </div>
        </div>
        <span aria-hidden="true" class="site-footer__details-chevron material-symbols-outlined">keyboard_arrow_down</span>
      </summary>

      <div class="site-footer__patent-list">
        <article>
          <span>01</span>
          <div>
            <h3>AI 시세예측을 통한 부동산 자산가치분석 시스템</h3>
            <p>특허 제10-2978387호</p>
            <small>AI-BASED REAL ESTATE ASSET VALUE ANALYSIS SYSTEM THROUGH PRICE FORECASTING</small>
          </div>
        </article>

        <article>
          <span>02</span>
          <div>
            <h3>부동산 권리분석 서비스 제공 시스템</h3>
            <p>특허 제10-2862942호</p>
            <small>SYSTEM FOR PROVIDING REAL ESTATE TITLE ANALYSIS SERVICE</small>
          </div>
        </article>
      </div>
    </details>

    <div class="site-footer__bottom">
      <p>Copyright © {{ currentYear }} CHECK team. All rights reserved.</p>
      <p>부동산을 확인하는 가장 안전한 습관, 체크팀</p>
    </div>
  </div>
</footer>
